export const navigateRef = {
    goTo: (path) => {
        console.warn('[NavigateRef] goTo is uninitialized.');
    },
};
